import React from 'react';
import { KccButtonProps } from './KccButton.types';
import { TYPE_TO_ANTD_TYPE } from './KccButton.constants';
import { StyledKccButton } from './KccButton.styles';

// NOTE: Multiple styling types of this component are not yet fully done or corrected.
// If you find any styling issue with a specific type, feel free to fix it.
// Must be used with KCC theme applied to Ant Design components, otherwise it will not look as intended.
export const KccButton = ({ type = 'primary', className, ...rest }: KccButtonProps): React.JSX.Element => (
  <StyledKccButton type={TYPE_TO_ANTD_TYPE[type]} $kccType={type} className={className} {...rest} />
);
